// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { Text } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

export default function BeerStyle({ beer, ...rest }) {
  if (!beer?.style) return null;
  return (
    <Section title={<Trans>Beer Style</Trans>} {...rest}>
      <Text>{beer.style}</Text>
    </Section>
  );
}

export const fragment = graphql`
  fragment BeerStyle on Beer {
    style
  }
`;

BeerStyle.fragment = gql`
  fragment BeerStyle on Beer {
    style
  }
`;
